import { render, staticRenderFns } from "./ThedoctorClinicNavbarVertical.vue?vue&type=template&id=c564cae0&"
import script from "./ThedoctorClinicNavbarVertical.vue?vue&type=script&lang=js&"
export * from "./ThedoctorClinicNavbarVertical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports